import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1355440236/src/src/app/@travelCardModal/(...)travelCard/[id]/page.tsx");
